import { makeVar } from '@apollo/client';

export const reSignIn = makeVar<boolean>(false);
